__turbopack_context__.v({
  "alert": "token-refund-module__SHVKUa__alert",
  "backButton": "token-refund-module__SHVKUa__backButton",
  "checkboxGroup": "token-refund-module__SHVKUa__checkboxGroup",
  "checkboxLabel": "token-refund-module__SHVKUa__checkboxLabel",
  "container": "token-refund-module__SHVKUa__container",
  "content": "token-refund-module__SHVKUa__content",
  "form": "token-refund-module__SHVKUa__form",
  "formGroup": "token-refund-module__SHVKUa__formGroup",
  "note": "token-refund-module__SHVKUa__note",
  "radioGroup": "token-refund-module__SHVKUa__radioGroup",
  "radioLabel": "token-refund-module__SHVKUa__radioLabel",
  "section": "token-refund-module__SHVKUa__section",
  "submitButton": "token-refund-module__SHVKUa__submitButton",
  "submitSection": "token-refund-module__SHVKUa__submitSection",
  "successMessage": "token-refund-module__SHVKUa__successMessage",
  "terms": "token-refund-module__SHVKUa__terms",
  "termsSection": "token-refund-module__SHVKUa__termsSection",
  "title": "token-refund-module__SHVKUa__title",
});
